export const getPercentageValue = (part, whole) => {
  if (
    !(typeof part !== 'number' && typeof whole !== 'number') ||
    !((isNaN(parseFloat(part)) && isNaN(parseFloat(whole))) || whole !== 0)
  ) {
    const percentage = parseFloat(part) / parseFloat(whole) * 100;
    return parseFloat(percentage.toFixed(2));
  }
  return 0;
};

export const getActiveSeatCount = (disableSeatCount, ttl_seat) => {
  const activeSeat = disableSeatCount ? ttl_seat - disableSeatCount : ttl_seat;
  return activeSeat;
};

export const getMajorityCount = (disableSeatCount, ttl_seat) =>
  disableSeatCount
    ? Math.floor((ttl_seat - disableSeatCount) / 2) + 1
    : Math.floor(ttl_seat / 2) + 1;

export function getExitPollDataForState(data) {
  if (
    typeof data !== 'object' ||
    !data ||
    !Array.isArray(data.alrslt) ||
    data.alrslt.length === 0
  ) {
    return {};
  }
  const electionData = data.alrslt;
  const meanTotal =
    electionData && Array.isArray(electionData)
      ? electionData.reduce(
          (acc, party) => acc + (party.minSeats + party.maxSeats) / 2,
          0,
        )
      : 0;
  if (meanTotal > 0) {
    const electionData1 =
      electionData && Array.isArray(electionData)
        ? electionData.map(curParty => ({
            an: curParty.an,
            color: curParty.cc,
            ls: curParty.minSeats || 0,
            wsc: curParty.maxSeats || 0,
            wscp:
              meanTotal > 0
                ? (curParty.minSeats + curParty.maxSeats / 2) * 100 / meanTotal
                : 0,
          }))
        : [];
    return electionData1;
  }
  return [];
}

export const shiftOthToRight = sortedPartyData => {
  let index1;
  if (
    sortedPartyData &&
    Array.isArray(sortedPartyData) &&
    sortedPartyData.length > 1
  ) {
    sortedPartyData.map((item, index) => {
      if (item.an === 'OTH') {
        index1 = index;
      }
      return index1;
    });
    if (index1 !== undefined) {
      const othData = sortedPartyData.splice(index1, 1);
      sortedPartyData.push(othData[0]);
    }
  }
  return sortedPartyData;
};

export const compareSeats = (a, b) => b.ls + b.ws - (a.ls + a.ws);

export const compareSeatsExitPolls = (a, b) => b.wscp - a.wscp;

export const getPartyListInSortedOrder = (data, isExitPoll) => {
  if (data && Array.isArray(data) && data.length > 0) {
    if (!isExitPoll) {
      data.sort(compareSeats);
    }
    data.sort(compareSeatsExitPolls);
  }
  return data;
};

export function filteredDataForExitPoll(data, givenStates) {
  const data1 = JSON.parse(JSON.stringify(data));
  const finalKeys = [];
  const finalSourceData = {};
  const totalDisabledSeats =
    givenStates && Array.isArray(givenStates)
      ? givenStates.reduce(
          (accumulator, state) =>
            accumulator +
            parseInt(
              isNaN(state?.disableSeatCount) ? 0 : state?.disableSeatCount,
              10,
            ),
          0,
        )
      : 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const key in data1) {
    if (data1?.[key]) {
      const { nation, states } = data1[key];

      if (
        nation &&
        nation?.india &&
        nation?.india?.alrslt &&
        Array.isArray(nation?.india?.alrslt) &&
        nation?.india?.alrslt.length > 0
      ) {
        nation.india.sortedAlRslt = getExitPollDataForState(nation.india);
        nation.india.sortedAlRslt = JSON.parse(
          JSON.stringify(
            shiftOthToRight(
              getPartyListInSortedOrder(nation.india.sortedAlRslt, true),
            ),
          ),
        );
        nation.india.activeSeats = getActiveSeatCount(
          totalDisabledSeats,
          nation?.india?.ttl_seat || 0,
        );
        nation.india.majority = getMajorityCount(
          totalDisabledSeats,
          nation?.india?.ttl_seat || 0,
        );
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const stateKey in states) {
        if (
          states?.[stateKey] &&
          states[stateKey]?.alrslt &&
          Array.isArray(states[stateKey]?.alrslt) &&
          states[stateKey]?.alrslt.length > 0
        ) {
          states[stateKey].sortedAlRslt = getExitPollDataForState(
            states[stateKey],
          );
          states[stateKey].sortedAlRslt = JSON.parse(
            JSON.stringify(
              shiftOthToRight(
                getPartyListInSortedOrder(states[stateKey].sortedAlRslt, true),
              ),
            ),
          );
          states[stateKey].name = states[stateKey]?.sn || '';
          states[stateKey].key = states[stateKey]?.sseo || '';
          if (
            states[stateKey].sortedAlRslt &&
            Array.isArray(states[stateKey].sortedAlRslt) &&
            states[stateKey].sortedAlRslt.length > 0
          ) {
            let stateInfo = givenStates.filter(state => state.key === stateKey);
            states[stateKey].activeSeats = states?.[stateKey]?.ttl_seat;
            if (stateInfo && Array.isArray(stateInfo) && stateInfo.length > 0) {
              stateInfo = stateInfo[0];
              states[stateKey].activeSeats = getActiveSeatCount(
                stateInfo?.disableSeatCount,
                states?.[stateKey]?.ttl_seat,
              );
              states[stateKey].infoMsg = stateInfo?.infoMsg || '';
              states[stateKey].powerState = stateInfo?.powerState || '';
            }
          } else {
            delete states[stateKey];
          }
        }
      }

      const statesArray = states ? Object.values(states) : [];

      if (
        (nation &&
          nation?.india &&
          nation?.india?.sortedAlRslt &&
          Array.isArray(nation?.india?.sortedAlRslt) &&
          nation?.india?.sortedAlRslt.length > 0) ||
        (statesArray && Array.isArray(statesArray) && statesArray.length > 0)
      ) {
        finalSourceData[key] = { nation, states };
        finalKeys.push({ name: key });
      }
    }
  }
  return {
    finalSourceData,
    exitPollSource: finalKeys,
    selectedSource:
      finalKeys && Array.isArray(finalKeys) && finalKeys.length > 0
        ? finalKeys[0]
        : '',
  };
}

export const getCountOfLeadPlusWins = data => {
  const seatCount = { winCount: 0, leadPlusWinCount: 0 };
  const party = data ? Object.keys(data) : [];
  for (let counter = 0; counter < party.length; counter += 1) {
    seatCount.leadPlusWinCount +=
      data?.[party[counter]]?.ls + data?.[party[counter]]?.ws || 0;
    seatCount.winCount += data?.[party[counter]]?.ws || 0;
  }
  if (isNaN(seatCount.winCount)) {
    seatCount.winCount = 0;
  }
  if (isNaN(seatCount.leadPlusWinCount)) {
    seatCount.leadPlusWinCount = 0;
  }
  return seatCount;
};

export const getLeadingParty = (
  sortedPartyData,
  ttl_seat,
  majority,
  colorMap,
) => {
  let leadingPartyObj = {};
  if (
    !Array.isArray(sortedPartyData) ||
    (sortedPartyData && sortedPartyData.length === 0)
  ) {
    return leadingPartyObj;
  }
  const [
    firstPartyData = { ws: 0, ls: 0 },
    secondPartyData = { ws: 0, ls: 0 },
  ] = [...sortedPartyData];
  const totalWonSeats =
    sortedPartyData && Array.isArray(sortedPartyData)
      ? sortedPartyData.reduce((total, partyData) => ({
          ws: total.ws + partyData.ws,
        }))
      : {};

  if (firstPartyData.ws >= majority) {
    //First party WON
    leadingPartyObj = {
      party: firstPartyData.nm,
      text: 'WON',
      color: colorMap[firstPartyData.nm].cc || firstPartyData.cc,
    };
  } else if (totalWonSeats.ws === ttl_seat && firstPartyData.ws < majority) {
    //Election over but Hung assembly
    leadingPartyObj = {
      party: 'HUNG',
      text: 'PARLIAMENT',
      color: '#595959',
    };
  } else if (
    firstPartyData.ws + firstPartyData.ls > majority ||
    firstPartyData.ws + firstPartyData.ls >
      secondPartyData.ws + secondPartyData.ls
  ) {
    //First party LEADING
    leadingPartyObj = {
      party: firstPartyData.nm,
      text: 'LEADING',
      color: colorMap[firstPartyData.nm].cc || firstPartyData.cc,
    };
  }
  if (leadingPartyObj.party === 'OTH') {
    leadingPartyObj = {};
  }
  return leadingPartyObj;
};

export const getAllianceMap = (partyData, allianceData) => {
  const allianceMap = {};
  const finalAllianceMap = [];
  if (partyData && Array.isArray(partyData)) {
    partyData.map(item => {
      if (item.al_id && item.al_id !== 1) {
        allianceMap[item.al_id] = allianceMap[item.al_id] || [];
        allianceMap[item.al_id].push(item);
      }
      return allianceMap;
    });
  }
  if (allianceData && Array.isArray(allianceData)) {
    allianceData.map(item => {
      if (allianceMap[item.a_id] && item.an) {
        finalAllianceMap.push({
          name: item.an,
          color: item.cc,
          data: allianceMap[item.a_id],
          totalSeats: item.ls + item.ws,
        });
      }
      return finalAllianceMap;
    });
  }
  return finalAllianceMap;
};

export const arrayToHashMap = (arr, key = 'an') => {
  const hashMap = {};
  if (arr && Array.isArray(arr)) {
    arr.forEach(item => {
      if (item?.[key]) {
        hashMap[item[key]] = item;
      }
    });
  }

  return hashMap;
};

export const getSortedViewDataForLokSabha = (
  data,
  states,
  alColorMap,
  prColorMap,
) => {
  const yrdata =
    data?.yrdata && Array.isArray(data.yrdata) && data.yrdata.length > 0
      ? data.yrdata[0]
      : {};
  yrdata.disableSeatCount =
    states && Array.isArray(states)
      ? states.reduce(
          (accumulator, state) =>
            accumulator +
            parseInt(
              isNaN(state?.disableSeatCount) ? 0 : state?.disableSeatCount,
              10,
            ),
          0,
        )
      : 0;
  yrdata.activeSeats = getActiveSeatCount(
    yrdata?.disableSeatCount,
    yrdata?.ttl_seats,
  );
  yrdata.majority = getMajorityCount(yrdata.disableSeatCount, yrdata.ttl_seats);
  yrdata.leadingAllianceObj = getLeadingParty(
    yrdata?.al_rslt,
    yrdata?.activeSeats,
    yrdata?.majority,
    alColorMap,
  );
  yrdata.leadingPartyObj = getLeadingParty(
    yrdata?.starpr_rslt,
    yrdata?.activeSeats,
    yrdata?.majority,
    prColorMap,
  );
  yrdata.leadPlusWinCount = getCountOfLeadPlusWins(yrdata?.starpr_rslt);
  if (
    yrdata.states &&
    Array.isArray(yrdata.states) &&
    yrdata.states.length > 0
  ) {
    yrdata.states =
      yrdata.states && Array.isArray(yrdata.states)
        ? yrdata.states.map(state => {
            let stateInfo =
              states && Array.isArray(states)
                ? states.filter(st => st.key === state.seonm)
                : [];
            if (stateInfo && Array.isArray(stateInfo) && stateInfo.length > 0) {
              stateInfo = stateInfo[0];
              state.activeSeats = getActiveSeatCount(
                stateInfo?.disableSeatCount,
                state?.ttl_seats,
              );
              state.infoMsg = stateInfo?.infoMsg || '';
              state.powerState = stateInfo?.powerState || '';
            }
            return state;
          })
        : [];
    yrdata.states = arrayToHashMap(
      yrdata.states && Array.isArray(yrdata.states)
        ? yrdata.states.sort((a, b) => a.nm.localeCompare(b.nm))
        : [],
      'seonm',
    );
  }
  return yrdata;
};
